import AbstractAction from "../AbstractAction";

export default class MassAppearanceAction extends AbstractAction {
    constructor(provider, elements, changes) {
        super(provider);
        this._elements = elements;
        this.properties = Object.keys(changes);

        this.oldValues = elements.map(el => {
            let old = {};
            this.properties.forEach(prop => {
                old[prop] = this.snap(el.appearance[prop]);
            });
            return old;
        });

        this.newValues = {};
        this.properties.forEach(prop => {
            this.newValues[prop] = this.snap(changes[prop]);
        });
    }

    snap(value) {
        if (value && value.levels) {
            value.setAlpha(255);
            return value.toString();
        }
        return value;
    }

    make(snapshot) {
        if (typeof snapshot === 'string') return this.p.color(snapshot);
        return snapshot;
    }

    update(changes) {
        for (let prop in changes) {
            this.newValues[prop] = this.snap(changes[prop]);
        }
        this.applyNew();
    }

    applyNew() {
        this._elements.forEach(el => {
            this.properties.forEach(prop => {
                el.appearance[prop] = this.make(this.newValues[prop]);
            });
            el.row?.updateImg();
        });
    }

    finish() {
        this.applyNew();
        let changed = this._elements.some((el, i) =>
            this.properties.some(prop =>
                this.newValues[prop] !== this.oldValues[i][prop]
            )
        );
        changed ? super.finish() : super.discard();
    }

    undo() {
        this._elements.forEach((el, i) => {
            this.properties.forEach(prop => {
                el.appearance[prop] = this.make(this.oldValues[i][prop]);
            });
            el.row?.updateImg();
        });
    }

    redo() {
        this.applyNew();
    }
}
